import React from 'react';
import styles from '../../Payyitme.module.css';
import { CheckIcon } from '../../icons';

const FeatureBlocks = () => (
  <>
    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={styles.feature}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />Your brand</span>
            <h2>Choose your own link.</h2>
            <p>Claim a memorable fyntiq.me/username that&apos;s yours to keep. Share it instantly with friends, customers, or partners — signing up is fast and free.</p>
            <ul className={styles.fList}>
              {['Custom fyntiq.me link', 'Works for personal & business', 'No website required', 'Start accepting money right away'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop} style={{ border: 'none', paddingBottom: 6 }}>
              <div className={styles.invNum} style={{ fontSize: 14 }}>Available links</div>
              <span className={styles.invLab}>CLAIM YOURS</span>
            </div>
            {[
              ['fyntiq.me/jordan', 'Available'],
              ['fyntiq.me/northbeam', 'Taken'],
              ['fyntiq.me/yourname', 'Available'],
            ].map(([link, status]) => (
              <div key={link} className={styles.recItem}>
                <span className={`${styles.recDot} ${status === 'Available' ? styles.recDotOn : styles.recDotOff}`} />
                <div className={styles.recFlex}><div className={styles.recName}>{link}</div><div className={styles.recMeta}>{status}</div></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>

    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={`${styles.feature} ${styles.featureFlip}`}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />Share anywhere</span>
            <h2>Share your link easily.</h2>
            <p>Drop your Lynk in a text, email, chat, Instagram bio, or print it on a business card. However you connect with people, your payment link goes with you.</p>
            <ul className={styles.fList}>
              {['Copy link in one tap', 'QR code for in-person', 'Embed in social bios', 'Add to email signature'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop}>
              <div><div className={styles.invLab}>SHARED VIA</div><div className={styles.invNum}>This week</div></div>
              <span className={styles.invStatus}>12 clicks</span>
            </div>
            {['Text message', 'Instagram bio', 'Email signature', 'QR at market'].map((ch) => (
              <div key={ch} className={styles.recItem}>
                <span className={`${styles.recDot} ${styles.recDotOn}`} />
                <div className={styles.recFlex}><div className={styles.recName}>{ch}</div></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>

    <section className={styles.sec} style={{ paddingTop: 0 }}>
      <div className={styles.container}>
        <div className={styles.feature}>
          <div className={`${styles.fText} ${styles.sr}`} data-sr>
            <span className={styles.eyebrow}><span className={styles.dot} />Speed</span>
            <h2>Get paid, real fast.</h2>
            <p>Friends, family, or customers follow your link, enter any amount, and pay their way. You get notified instantly and funds land on your schedule.</p>
            <ul className={styles.fList}>
              {['Wallet, card & bank accepted', 'Instant payment notifications', 'Secure, encrypted checkout', 'Works on any device'].map((t) => (
                <li key={t}><CheckIcon />{t}</li>
              ))}
            </ul>
          </div>
          <div className={`${styles.fVisual} ${styles.sr}`} data-sr>
            <div className={styles.invTop}>
              <div><div className={styles.invLab}>PAYMENT</div><div className={styles.invNum}>From Alex M.</div></div>
              <span className={styles.invStatus} style={{ background: 'var(--green-soft)', color: 'var(--green)' }}>Received</span>
            </div>
            <div className={styles.invRow}><span>Amount</span><span className={styles.mono}>$48.00</span></div>
            <div className={styles.invRow}><span>Method</span><span className={styles.mono}>Fyntiq Wallet</span></div>
            <div className={styles.invTotal}><span>Deposited</span><span className={styles.mono}>Today</span></div>
            <div className={styles.invPaynow} style={{ background: 'var(--green)' }}>Payment received ✓</div>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default FeatureBlocks;
